import React, { useState, useEffect } from 'react';
import Table from 'react-bootstrap/Table'
import MajorCourseService from '../../service/majorCourseService'
import useToken from '../../App/useToken';
import './MajorCourse.css'

export default function MajorCourse() {
  const { getToken } = useToken();
  const token = getToken();
  const [isLoading, setIsLoading] = useState(true);
  const [basicMajorCourses, setBasicMajorCourse] = useState([]);
  const [finalMajorCourses, setFinalMajorCourse] = useState([]);
  useEffect(() => {
    const getMajorCourse = async () => {
      const majorCourseService = new MajorCourseService()
      const res = await majorCourseService.getMajorCourse(token);
      if (res.final && res.basic) {
        setFinalMajorCourse(res.final);
        setBasicMajorCourse(res.basic);
      }
    }
    getMajorCourse();
    setIsLoading(false);
  }, []);

  const handleRedirect = (active, courseName) => {
    if (active) {
      window.location.href = `/majorcourses/${courseName}`
    }
  }

  return(
    <div className="course-list container">
      {!isLoading && <div clalssname="container">
        <span className='title'>คลิกเลือกหลักสูตรที่ต้องการจัดทำบัญชีผู้สมัครเข้ารับการศึกษา</span>
        <div className='major-course-container row'>
          <div className='col major-course-table'>
            <Table striped >
              <thead>
                <tr>
                  <th><span className='table-title'>หลักสูตรขั้นปลาย</span></th>
                </tr>
              </thead>
              <tbody>
                {(finalMajorCourses !== []) && finalMajorCourses.map((finalMajorCourse, index) => (
                  <tr key={finalMajorCourse._id} onClick={() => {handleRedirect(finalMajorCourse.is_active, finalMajorCourse.name)}}>
                    <td className={!finalMajorCourse.is_active ? 'disabled' : ''} style={{ textAlign: 'center' }}>{finalMajorCourse.name} {finalMajorCourse.is_spc_approve ? (
                      <>***</> 
                    ) : <></>}</td>
                  </tr>
                ))}
              </tbody>
            </Table>
          </div>
          <div className='col major-course-table'>
            <Table striped >
              <thead>
                <tr>
                  <th><span className='table-title'>หลักสูตรขั้นต้น</span></th>
                </tr>
              </thead>
              <tbody>
                {(basicMajorCourses !== []) && basicMajorCourses.map((basicMajorCourse, index) => ( 
                  <tr key={basicMajorCourse._id} onClick={() => {handleRedirect(basicMajorCourse.is_active, basicMajorCourse.name)}}>
                    <td className={!basicMajorCourse.is_active ? 'disabled' : ''} style={{ textAlign: 'center' }}>{basicMajorCourse.name} {basicMajorCourse.is_spc_approve ? (
                      <>***</> 
                    ) : <></>}</td>
                  </tr>
                ))}
              </tbody>
            </Table>
          </div>
          <span>*** หลักสูตรที่ต้องผ่านหน่วย หน.สายวิทยาการ เพื่อพิจารณาก่อน</span>
        </div>
      </div>}
    </div>
  )
}
